import React, { useEffect } from 'react';

import { useToast } from '@chakra-ui/react';

import { onSnackBarClose } from '@/context/redux/SnackBarProvider';
import { useAppDispatch, useAppSelector } from '@/context/redux/store';

import { translate } from '../Translate';

const Toast = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { open, type, msg } = useAppSelector((state) => state.snackBar);
  const translatedMsg = translate(msg);

  useEffect(() => {
    if (open) {
      toast({
        title: translatedMsg,
        status: type,
        position: 'top',
        duration: 6000,
        isClosable: true,
      });
      dispatch(onSnackBarClose());
    }
  }, [translatedMsg, open]);

  return <></>;
};

export default Toast;
